import BaseModel from './BaseModel';

class HeadUserFilters extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.zone_ids = data.zone_ids || [];
    this.branch_ids = data.branch_ids || [];
    this.cluster_ids = data.cluster_ids || [];
    this.users_type_ids = data.users_type_ids || [];
    this.active = (data.active === true || data.active === false ? data.active : true);
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      head_user: {
        zone_ids: this.zone_ids,
        branch_ids: this.branch_ids,
        cluster_ids: this.cluster_ids,
        users_type_ids: this.users_type_ids,
        active: this.active,
      }
    }
  }

  validations = (field) => {
    return {
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default HeadUserFilters;
